import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const StaffNotebookLogoInverted32Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M64 1791V263L1216 56v1936L64 1791zM321 660v706l115 6V854l307 534 154 9V631l-145 8v257q0 128 1 257L467 655l-146 5zm1637 172q13 0 19 12t7 24v248q0 11-6 23t-20 13h-38V832h38zm0 384q13 0 19 12t7 24v248q0 11-6 23t-20 13h-38v-320h38zm26-469q0 13-3 17t-17 4h-108v909q0 7-2 16t-7 16-11 13-15 6h-541v-192h384v-64h-384v-128h384v-64h-384V819l192 77 192-77v173q0 14 9 23t23 9q14 0 23-9t9-23V794l64-26-320-128-192 77V320h541q20 0 27 17t8 34v77h108q14 0 17 3t3 18v278zm-384 277v-93l-128 51-128-51v93q0 19 15 31t36 19 42 11 35 3q13 0 34-3t43-10 36-20 15-31z" />
    </svg>
  ),
  displayName: 'StaffNotebookLogoInverted32Icon',
});

export default StaffNotebookLogoInverted32Icon;
